module.exports = __webpack_public_path__ + "static/gallery_03-thumb-e772c7e2603a8032d051f48fe7d02e86.jpg";